// NOTE: this is a temporary solution for special clients that have a metric ton of websites/licenses.
// This will be completely redone to use a permission based system in the back-end (refactor underway).
// See thread for more details: https://termly.slack.com/archives/C016M8U8Q72/p1662731901168099
import { useLocation } from 'react-router-dom'

import Paths from 'constants/paths'

import usePlansQuery from 'hooks/usePlansQuery'

const FIS = 1501

const WHITELISTED_CLIENTS = new Set([
  FIS,
])

const WHITELISTED_PAGES = new Set([
  Paths.USER_MANAGEMENT,
])


export default function useWhitelist() {
  const { pathname } = useLocation()

  const {
    isLoading,
    currentUserPlan,
  } = usePlansQuery()

  return {
    isLoading,
    isPageWhitelisted: WHITELISTED_PAGES.has(pathname),
    isPlanWhitelisted: WHITELISTED_CLIENTS.has(currentUserPlan?.id),
  }
}
